// Lib Imports
import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Box, Button } from 'grommet';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

// CORE Imports
import FormField from 'granite-admin/core/components/CustomFormField';
import OtpInput from 'granite-admin/core/components/OtpInput';
const SubmitTokenForm = ({
  onSubmit,
  resendToken,
  retry,
  formikRef
}) => {
  const validationSchema = Yup.object().shape({
    token: Yup.string().min(6, 'Too Short!').max(6, 'Too Long!').required('Token is required')
  });
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      token: ''
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    innerRef: formikRef
  }, ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  }) => /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(FormField, {
    name: "token",
    label: "Enter the OTP",
    required: true,
    error: touched.token && errors.token
  }, /*#__PURE__*/React.createElement(OtpInput, {
    name: "token",
    numInputs: 6,
    onChange: otp => setFieldValue('token', otp),
    onBlur: handleBlur,
    value: values.token
  })), /*#__PURE__*/React.createElement(Box, {
    fill: "horizontal",
    direction: "row-responsive",
    elevation: "none",
    justify: "between",
    align: "center",
    margin: {
      vertical: 'medium',
      bottom: '0'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    alignSelf: "start"
    // margin={{ vertical: 'small' }}
    ,
    label: isSubmitting ? 'Submitting...' : 'Submit',
    disabled: isSubmitting,
    primary: true,
    color: "secondary",
    margin: {
      vertical: 'medium',
      bottom: '0'
    }
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/login"
  }, /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    color: "secondary",
    label: "Log in to existing account",
    size: "small",
    margin: {
      vertical: 'small',
      bottom: '0'
    }
  }))), retry ? /*#__PURE__*/React.createElement(Button, {
    color: "brand",
    label: "Send OTP again",
    onClick: resendToken,
    margin: {
      top: 'xsmall'
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)));
};
SubmitTokenForm.propTypes = {
  onSubmit: PropTypes.func,
  resendToken: PropTypes.func,
  retry: PropTypes.bool
};
export default SubmitTokenForm;